<nav class="header" [class.dark]="color() === 'dark'" [class.light]="color() === 'light'">
  <a class="logo">
    @if (color() === 'dark') {
      <img src="assets/images/YoutopiaIconWhite.svg" alt="Youtopia Logo" />
    } @else {
      <img src="assets/images/YoutopiaIcon.svg" alt="Youtopia Logo" />
    }
    <span class="youtopia">{{ 'Common.Youtopia' | translate }}</span>
    <span class="partner">{{ 'Common.Partner' | translate }}</span>
  </a>
  @if (authUser() && producer() && producerUser()) {
    <ul class="navbar" [class.expanded]="isNavbarOpen()">
      @for (item of navItems(); track item) {
        <li class="navbar-item">
          <a
            class="nav-link"
            aria-current="page"
            routerLinkActive="active"
            [routerLink]="item.routerLink"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="isNavbarOpen.set(false)"
          >
            {{ `Navigation.${item.label}` | translate }}
          </a>
        </li>
      }
    </ul>
    <div class="right">
      <div class="nav-item profile-button" (click)="userDetails.toggle($event)">
        <i class="down-icon pi pi-angle-down"></i>
        @if (authUser(); as user) {
          <img class="profile-image" [title]="user.displayName" [src]="producerUser()?.imageUrl || '' | safe: 'url'" />
        }
      </div>
      <button class="navbar-toggler" [class.expanded]="isNavbarOpen()" (click)="toggleNavbar()">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
  } @else {
    <yt-y-button
      data-testid="loginBtn"
      [color]="ButtonType.Selection"
      [label]="'Landing.Log_In' | translate"
      [outlined]="true"
      (click)="login()"
    ></yt-y-button>
  }
</nav>

<p-popover #userDetails styleClass="ov-panel">
  <yt-profile-overlay></yt-profile-overlay>
  <p-popover></p-popover>
</p-popover>
